import { useState } from "react";
import { OrderAddress } from "../styled";
import { useRegex } from "../../../../../hooks/useRegex";

const Address = ({ addresses, selection, setAddressModal }) => {
  const [customMemo, setCustomMemo] = useState("");
  const [selectedMemo, setSelectedMemo] = useState(selection?.memo || "");

  const { TelFormat } = useRegex();

  const options = [
    "문 앞에 놔주세요",
    "경비실에 맡겨주세요",
    "택배함에 넣어주세요",
    "배송 전 연락 주세요",
    "직접 입력",
  ];

  return (
    <OrderAddress>
      <div className="address">
        <div className="title">
          {selection ? (
            <p>
              <strong>{selection.nickname}</strong>
              {selection.isDefault && <span>기본배송지</span>}
            </p>
          ) : (
            <p>
              <span>등록된 배송지가 존재하지 않습니다.</span>
            </p>
          )}
          <button className="addr" onClick={() => setAddressModal(selection ? "select" : "form")}>
            배송지 {selection ? "변경" : "등록"}
          </button>
        </div>
        {selection && (
          <div className="info">
            <span>
              ({selection.postcode}) {selection.address}
              {selection.detailAddress && ` ${selection.detailAddress}`}
            </span>
            <span>{TelFormat(selection.phone)}</span>
          </div>
        )}
        {selection && (
          <div className="memo">
            <select
              value={selectedMemo}
              onChange={(e) => {
                const val = e.target.value;
                setSelectedMemo(val);
                if (val !== "직접 입력") setCustomMemo("");
              }}>
              {[...new Set([selection.memo && selection.memo, ...options])]
                .filter(Boolean)
                .map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
            </select>
            {selectedMemo === "직접 입력" && (
              <textarea
                placeholder="배송 메모를 입력하세요"
                value={customMemo}
                onChange={(e) => setCustomMemo(e.target.value)}
              />
            )}
          </div>
        )}
      </div>
    </OrderAddress>
  );
};

export default Address;
